const translationKeys = {
  hunting_customer_consent_co_borrower_consent_card_title:
    'hunting_customer_consent_co_borrower_consent_card_title',
  hunting_customer_consent_co_borrower_consent_card_text_condition_description:
    'hunting_customer_consent_co_borrower_consent_card_text_condition_description',
  hunting_customer_consent_co_borrower_consent_card_text_bullet_one:
    'hunting_customer_consent_co_borrower_consent_card_text_bullet_one',
  hunting_customer_consent_co_borrower_consent_card_text_bullet_two:
    'hunting_customer_consent_co_borrower_consent_card_text_bullet_two',
  hunting_customer_consent_co_borrower_consent_card_text_bullet_three:
    'hunting_customer_consent_co_borrower_consent_card_text_bullet_three',
  hunting_customer_consent_co_borrower_consent_card_button_accept:
    'hunting_customer_consent_co_borrower_consent_card_button_accept',
  hunting_customer_consent_co_borrower_consent_card_button_decline:
    'hunting_customer_consent_co_borrower_consent_card_button_decline',
  hunting_customer_consent_altinn_consent_card_title:
    'hunting_customer_consent_altinn_consent_card_title',
  hunting_customer_consent_altinn_consent_card_text_condition_description:
    'hunting_customer_consent_altinn_consent_card_text_condition_description',
  hunting_customer_consent_altinn_consent_card_text_bullet_one:
    'hunting_customer_consent_altinn_consent_card_text_bullet_one',
  hunting_customer_consent_altinn_consent_card_button_accept:
    'hunting_customer_consent_altinn_consent_card_button_accept',
  hunting_customer_consent_altinn_consent_card_text_bullet_two:
    'hunting_customer_consent_altinn_consent_card_text_bullet_two',
  hunting_customer_consent_altinn_consent_card_text_bullet_three:
    'hunting_customer_consent_altinn_consent_card_text_bullet_three',
  hunting_customer_consent_altinn_consent_card_text_bankid_description:
    'hunting_customer_consent_altinn_consent_card_text_bankid_description',
  hunting_customer_consent_title: 'hunting_customer_consent_title',
  hunting_customer_consent_co_borrower_reject_card_title:
    'hunting_customer_consent_co_borrower_reject_card_title',
  hunting_customer_consent_co_borrower_reject_card_text:
    'hunting_customer_consent_co_borrower_reject_card_text',
  hunting_customer_consent_co_borrower_reject_card_button:
    'hunting_customer_consent_co_borrower_reject_card_button',
  hunting_customer_consent_error_state_title:
    'hunting_customer_consent_error_state_title',
  hunting_customer_consent_error_state_text:
    'hunting_customer_consent_error_state_text',
  hunting_customer_consent_approved_card_title:
    'hunting_customer_consent_approved_card_title',
  hunting_customer_consent_approved_card_text_one:
    'hunting_customer_consent_approved_card_text_one',
  hunting_customer_consent_approved_card_text_two:
    'hunting_customer_consent_approved_card_text_two',
  hunting_customer_consent_approved_card_button:
    'hunting_customer_consent_approved_card_button',
};

Object.freeze(translationKeys);

export default translationKeys;
